<template>
  <div class="miniTitle" ref="title" :class="{'underln': underline, 'centered': centered}">{{text}}</div>
</template>

<script>
export default {
  name: "SubTitle",
  props: ["text", "color", "underline", "centered"],
  data() {
    return {};
  },
  mounted() {
    if (this.color) {
      this.$refs.title.style.color = this.color;
      if (this.underline) {
        this.$refs.title.style.borderColor = this.color;
      }
    }
  }
};
</script>

<style scoped lang="less">
.underln {
  padding-bottom: 8px;
  border-bottom: 1px solid #336699;
}

.centered {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/ui/subTitle.vue